export function sortColumnsBySortingInfo(columns) {
    return [...columns].sort((a, b) => {
        var _a, _b, _c, _d;
        const aGroup = (_a = a.sortingInfo) === null || _a === void 0 ? void 0 : _a.groupIndex;
        const bGroup = (_b = b.sortingInfo) === null || _b === void 0 ? void 0 : _b.groupIndex;
        const aHasGroup = isNullOrUndefined(aGroup) === false;
        const bHasGroup = isNullOrUndefined(bGroup) === false;
        if (aHasGroup !== bHasGroup) {
            return aHasGroup ? -1 : 1;
        }
        if (aHasGroup && bHasGroup && aGroup !== bGroup) {
            return aGroup - bGroup;
        }
        const aIndex = (_c = a.sortingInfo) === null || _c === void 0 ? void 0 : _c.index;
        const bIndex = (_d = b.sortingInfo) === null || _d === void 0 ? void 0 : _d.index;
        const aHasIndex = isNullOrUndefined(aIndex) === false;
        const bHasIndex = isNullOrUndefined(bIndex) === false;
        if (aHasIndex !== bHasIndex) {
            return aHasIndex ? -1 : 1;
        }
        if (aHasIndex && bHasIndex) {
            return aIndex - bIndex;
        }
        return 0;
    });
}
